import i18next from 'i18next';
import React from 'react';
import { Button } from '../../components/forms/Buttons/Button';
import { clearDraft } from '../../utils/helpers/registrationDraft';

// Черновик переживает F5, поэтому ошибка рендера из-за него повторялась бы
// после каждой перезагрузки. Удаляем его: следующая загрузка начнётся с нуля.
export default class DraftErrorBoundary extends React.Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch() {
    clearDraft();
  }

  render() {
    if (!this.state.failed) return this.props.children;

    return (
      <div className='mt-12 flex flex-col items-center gap-4 px-4'>
        <p>{i18next.t('signup.something_went_wrong_refresh')}</p>
        <Button
          text={i18next.t('buttons.retry')}
          onClick={() => window.location.reload()}
        />
      </div>
    );
  }
}
